import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgSuccess = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-3.293-7.707L10 13.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414z" }));
};
export default factorySvgIcon(SvgSuccess);
//# sourceMappingURL=SvgSuccess.js.map